import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';
import { Box } from '@/src/packages/components/ui/Box';
import Image from 'next/image';
import Balancer from 'react-wrap-balancer';

export const ProductSketch = () => {
  const { productVariant } = useProductContext();

  return (
    <Box className="flex items-center justify-center flex-col py-0 text-center px-12 mb-8">
      {productVariant.product.sketch && (
        <Image
          src={productVariant.product.sketch.fields.file.url}
          alt=""
          className="object-contain"
          width={400}
          height={400}
        />
      )}

      <Box className="flex-1 max-w-xl font-serif text-xl lg:text-2xl">
        <Balancer>{productVariant.description}</Balancer>
      </Box>
    </Box>
  );
};
